import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { IconName } from '@vsolv/vectors-ui/icons';
import { ThemeColor } from '@vsolv/vectors-ui/theming';
import { isObservable, Observable, of } from 'rxjs';
import { TableCellComponent } from '../../models';

export interface IconCellProps {
  icon: IconName | null;
  theme?: ThemeColor;
  size?: number;
  hideBackground?: boolean;
  containerClasses?: string | Observable<string>;

  iconTooltip?: string | { title: string; subtitle: string } | { template: TemplateRef<unknown>; context?: object };

  click?($event: Event): void | Promise<void>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  template: `
    <ng-container *vsLet="classes$ | async as classes">
      <div
        *ngIf="data && data.icon"
        class="flex justify-center p-2 rounded-full {{ classes }}"
        [class.bg-themed-50]="!data.hideBackground"
        [theme]="data.theme ?? 'primary'"
        (click)="_click($event)"
      >
        <vs-icon
          tooltipStyle="light"
          class="self-center text-themed-500"
          [name]="data.icon"
          [size]="data.size ?? 24"
          [vsTooltip]="data.iconTooltip"
          [theme]="data.theme ?? 'primary'"
        ></vs-icon>
      </div>
    </ng-container>
  `,
})
export class IconCellComponent extends TableCellComponent<IconCellProps> {
  get classes$() {
    return isObservable(this.data?.containerClasses)
      ? this.data?.containerClasses
      : of(this.data?.containerClasses ?? '');
  }

  async _click($event: Event) {
    await this.data?.click?.($event);
  }
}
